import type { ReactNode } from 'react';

import { GLASS_SURFACE, WHITE_PANEL_SURFACE } from '@/components/objectives/objectiveStyles';

interface GlassFrameProps {
    children: ReactNode;
    dataTestId?: string;
}

interface IconCircleProps {
    children: ReactNode;
    className: string;
}

/**
 * A glass surface whose responsive padding comes from `.obj-frame` in `app.css`: a base padding
 * utility beats its own `md:` variant in this Tailwind v4 build, so the two widths are real
 * media queries instead of `p-4 md:p-8` (see the note above that rule).
 */
export function GlassFrame({ children, dataTestId }: GlassFrameProps) {
    return (
        <div
            className={`obj-frame ${GLASS_SURFACE}`}
            data-testid={dataTestId}
        >
            {children}
        </div>
    );
}

/** The white panel a `GlassFrame` wraps; its padding comes from `.obj-panel` for the same reason. */
export function WhitePanel({ children }: { children: ReactNode }) {
    return <div className={`obj-panel ${WHITE_PANEL_SURFACE}`}>{children}</div>;
}

/** The round tile the prototype puts behind a glyph. Its size and fill come from `className`. */
export function IconCircle({ children, className }: IconCircleProps) {
    return (
        <div className={`flex flex-shrink-0 items-center justify-center rounded-full ${className}`}>
            {children}
        </div>
    );
}
